import * as React from 'react';
import './homepage.scss';
import { IHistory } from '../../interfaces';
import { Icon } from '../reusableComponents/Icon';

export interface IHomePageCardProps {
    icon: string;
    label: string;
    history: IHistory;
    className?: string;
    location: string;
}

export class HomePageCard extends React.PureComponent<IHomePageCardProps, {}> {
    constructor(props: IHomePageCardProps) {
        super(props);
    }

    public render() {
        const { icon, label, className, history, location } = this.props;
        return <div onClick={() => history.push(location)} className={`homepage-card ${className}`}>
            <Icon icon={icon} />
            <div className="label" >{label}</div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Home/HomePageCard.tsx